import { atom } from 'jotai';

import { ObjectValues } from 'src/common/tsHelpers';
import { Routes } from 'src/Routes.constants';

export const PAGES = {
  PRODUCTS: 'products',
  INVENTORY: 'inventory',
  PROVISIONING: 'provisioning',
  ADMIN: 'admin',
  DASHBOARD: 'dashboard',
  LOCATIONS: 'locations',
  ACTIVITY_LOG: 'activity_log',
} as const;

export type PageName = ObjectValues<typeof PAGES>;

const getInitialPage = () => {
  if (globalThis.location.pathname.includes(Routes.locations)) {
    return PAGES.LOCATIONS;
  }

  if (globalThis.location.pathname.includes(Routes.activityLog)) {
    return PAGES.ACTIVITY_LOG;
  }

  if (globalThis.location.pathname.includes(Routes.products)) {
    return PAGES.PRODUCTS;
  }

  if (globalThis.location.pathname.includes(Routes.admin)) {
    return PAGES.ADMIN;
  }

  if (globalThis.location.pathname.includes(Routes.simInventory)) {
    return PAGES.INVENTORY;
  }

  return PAGES.DASHBOARD;
};

export const pageAtom = atom<PageName>(getInitialPage());

export const productNavigationAtom = atom<string>(Routes.tariffSummary);

export const adminNavigationAtom = atom<string>(Routes.customFields);

export const activityLogNavigationAtom = atom<string>(Routes.productsManagement);
